import { render, staticRenderFns } from "./weditor.vue?vue&type=template&id=36445e1e"
import script from "./weditor.vue?vue&type=script&lang=js"
export * from "./weditor.vue?vue&type=script&lang=js"
import style0 from "./weditor.vue?vue&type=style&index=0&id=36445e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports